var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Recap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.4536529%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "13.2103863%",
    x2: "78.7447867%",
    y2: "86.2935911%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7405",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10_Chapter_page",
    transform: "translate(-504.000000, -645.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(490.000000, 592.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Recap",
    transform: "translate(12.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_icon",
    transform: "translate(2.181818, 2.836364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.8701049 L0,17.1910535 C0,18.0867655 0.68627076,18.8155594 1.52972028,18.8155594 L18.0506993,18.8155594 C18.8941488,18.8155594 19.5804196,18.0867655 19.5804196,17.1910535 L19.5804196,3.8701049 L0,3.8701049 Z",
    id: "Path",
    fill: "#005DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.8701049 L0,17.1910535 C0,18.0867655 0.68627076,18.8155594 1.52972028,18.8155594 L17.2348485,18.8155594 C18.078298,18.8155594 18.7645688,18.0867655 18.7645688,17.1910535 L18.7645688,3.8701049 L0,3.8701049 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0506993,0.458916084 L1.52972028,0.458916084 C0.68627076,0.458916084 0,1.14518684 0,1.98863636 L0,4.08758741 L19.5804196,4.08758741 L19.5804196,1.98863636 C19.5804196,1.14518684 18.8941106,0.458916084 18.0506993,0.458916084 Z M2.44755245,3.51835664 C1.94064139,3.51835664 1.52972028,3.10743553 1.52972028,2.60052448 C1.52972028,2.09361342 1.94064139,1.68269231 2.44755245,1.68269231 C2.95446351,1.68269231 3.36538462,2.09361342 3.36538462,2.60052448 C3.36538462,3.10743553 2.95446351,3.51835664 2.44755245,3.51835664 Z M17.1328671,3.51835664 C16.6259561,3.51835664 16.215035,3.10743553 16.215035,2.60052448 C16.215035,2.09361342 16.6259561,1.68269231 17.1328671,1.68269231 C17.6397782,1.68269231 18.0506993,2.09361342 18.0506993,2.60052448 C18.0506993,3.10743553 17.6397782,3.51835664 17.1328671,3.51835664 Z",
    id: "Shape",
    fill: "#FF6813",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2348485,0.458916084 L1.52972028,0.458916084 C0.68627076,0.458916084 0,1.14518684 0,1.98863636 L0,4.08758741 L18.7645688,4.08758741 L18.7645688,1.98863636 C18.7645688,1.14518684 18.0782598,0.458916084 17.2348485,0.458916084 Z M2.44755245,3.51835664 C1.94064139,3.51835664 1.52972028,3.10743553 1.52972028,2.60052448 C1.52972028,2.09361342 1.94064139,1.68269231 2.44755245,1.68269231 C2.95446351,1.68269231 3.36538462,2.09361342 3.36538462,2.60052448 C3.36538462,3.10743553 2.95446351,3.51835664 2.44755245,3.51835664 Z M17.1328671,3.51835664 C16.6259561,3.51835664 16.215035,3.10743553 16.215035,2.60052448 C16.215035,2.09361342 16.6259561,1.68269231 17.1328671,1.68269231 C17.6397782,1.68269231 18.0506993,2.09361342 18.0506993,2.60052448 C18.0506993,3.10743553 17.6397782,3.51835664 17.1328671,3.51835664 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.945455, 6.218182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3933562,1.77635684e-15 C11.6280053,1.77635684e-15 11.005594,0.62241132 11.005594,1.38776214 C11.005594,2.15311296 11.6280053,2.77552428 12.3933562,2.77552428 C13.158707,2.77552428 13.7811183,2.15311296 13.7811183,1.38776214 C13.7811183,0.62241132 13.158707,1.77635684e-15 12.3933562,1.77635684e-15 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89055915,1.77635684e-15 C6.12520833,1.77635684e-15 5.50279701,0.62241132 5.50279701,1.38776214 C5.50279701,2.15311296 6.12520833,2.77552428 6.89055915,2.77552428 C7.65590997,2.77552428 8.27832129,2.15311296 8.27832129,1.38776214 C8.27832129,0.62241132 7.65590997,1.77635684e-15 6.89055915,1.77635684e-15 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38776214,1.77635684e-15 C0.62241132,1.77635684e-15 -2.25774954e-12,0.62241132 -2.25774954e-12,1.38776214 C-2.25774954e-12,2.15311296 0.62241132,2.77552428 1.38776214,2.77552428 C2.15311296,2.77552428 2.77552428,2.15311296 2.77552428,1.38776214 C2.77552428,0.62241132 2.15311296,1.77635684e-15 1.38776214,1.77635684e-15 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3933562,4.1937061 C11.6280053,4.1937061 11.005594,4.81611742 11.005594,5.58146824 C11.005594,6.34681906 11.6280053,6.96923038 12.3933562,6.96923038 C13.158707,6.96923038 13.7811183,6.34681906 13.7811183,5.58146824 C13.7811183,4.81611742 13.158707,4.1937061 12.3933562,4.1937061 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89055915,4.1937061 C6.12520833,4.1937061 5.50279701,4.81611742 5.50279701,5.58146824 C5.50279701,6.34681906 6.12520833,6.96923038 6.89055915,6.96923038 C7.65590997,6.96923038 8.27832129,6.34681906 8.27832129,5.58146824 C8.27832129,4.81611742 7.65590997,4.1937061 6.89055915,4.1937061 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38776214,4.1937061 C0.62241132,4.1937061 -2.25774954e-12,4.81611742 -2.25774954e-12,5.58146824 C-2.25774954e-12,6.34681906 0.62241132,6.96923038 1.38776214,6.96923038 C2.15311296,6.96923038 2.77552428,6.34681906 2.77552428,5.58146824 C2.77552428,4.81611742 2.15311296,4.1937061 1.38776214,4.1937061 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3933562,8.3874122 C11.6280053,8.3874122 11.005594,9.00982352 11.005594,9.77517434 C11.005594,10.5405252 11.6280053,11.1629365 12.3933562,11.1629365 C13.158707,11.1629365 13.7811183,10.5405252 13.7811183,9.77517434 C13.7811183,9.00978015 13.158707,8.3874122 12.3933562,8.3874122 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89055915,8.3874122 C6.12520833,8.3874122 5.50279701,9.00982352 5.50279701,9.77517434 C5.50279701,10.5405252 6.12520833,11.1629365 6.89055915,11.1629365 C7.65590997,11.1629365 8.27832129,10.5405252 8.27832129,9.77517434 C8.27832129,9.00978015 7.65590997,8.3874122 6.89055915,8.3874122 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38776214,8.3874122 C0.62241132,8.3874122 -2.25774954e-12,9.00982352 -2.25774954e-12,9.77517434 C-2.25774954e-12,10.5405252 0.62241132,11.1629365 1.38776214,11.1629365 C2.15311296,11.1629365 2.77552428,10.5405252 2.77552428,9.77517434 C2.77552428,9.00978015 2.15311296,8.3874122 1.38776214,8.3874122 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.44755245,3.05944056 C2.19419253,3.05944056 1.98863636,2.85403737 1.98863636,2.60052448 L1.98863636,0.458916084 C1.98863636,0.205403191 2.19419253,0 2.44755245,0 C2.70091237,0 2.90646853,0.205403191 2.90646853,0.458916084 L2.90646853,2.60052448 C2.90646853,2.85403737 2.70091237,3.05944056 2.44755245,3.05944056 Z",
    id: "Path",
    fill: "#005DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1328671,3.05944056 C16.8795072,3.05944056 16.673951,2.85403737 16.673951,2.60052448 L16.673951,0.458916084 C16.673951,0.205403191 16.8795072,0 17.1328671,0 C17.3862271,0 17.5917832,0.205403191 17.5917832,0.458916084 L17.5917832,2.60052448 C17.5917832,2.85403737 17.3862271,3.05944056 17.1328671,3.05944056 Z",
    id: "Path",
    fill: "#005DCC"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapIcon);
export default __webpack_public_path__ + "static/media/recap-icon.949ee99b43c710a5fc228a096f33bac9.svg";
export { ForwardRef as ReactComponent };